const T4i = () => import(/* webpackChunkName: "T4i" */ "@/views/t4i/T4i");
const T4iList = () => import(/* webpackChunkName: "T4i List" */ "@/views/t4i/T4iList");
const T4iEdit = () => import(/* webpackChunkName: "T4i Edit" */ "@/views/t4i/T4iEdit");
// const BenefitsNew = () => import(/* webpackChunkName: "Benefits New" */ "@/views/benefits/BenefitsNew");

const t4iRoutes = [
  {
    path: "t4i",
    name: "T4i",
    redirect: {
      name: "T4i List"
    },
    component: T4i,
    children: [
      {
        path: "list",
        name: "T4i List",
        component: T4iList
      },
      // {
      //   path: "new",
      //   name: "Benefits New",
      //   component: BenefitsNew
      // },
      {
        path: "edit/:id",
        name: "T4i Edit",
        component: T4iEdit,
        props: true
      }
    ]
  }
];

export default t4iRoutes;